"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vf_player_config_1 = require("../interfaces/vf-player-config");
var VFConfigManager = (function () {
    function VFConfigManager(config) {
        this.config = config;
    }
    VFConfigManager.CreateInstance = function (config) {
        if (config === void 0) { config = {}; }
        if (!this.Instance) {
            var mergedConfig = __assign(__assign({}, this.GetDefaultConfig()), config);
            this.Instance = new VFConfigManager(mergedConfig);
        }
        return this.Instance;
    };
    VFConfigManager.GetConfig = function () {
        return this.Instance.config;
    };
    VFConfigManager.GetDefaultConfig = function () {
        return {
            sceneType: vf_player_config_1.VFSceneType.DefaultOrbitScene,
            sceneClearColor: "#F6F6F6FF",
            enableEnvironment: true,
            enableAmbientOcclusion: false,
            enableGroundMirror: false,
            groundColor: null,
            groundTextureURL: "assets/images/ground_texture.png",
            environmentMapURL: "assets/images/environment-map/",
            webGlVersion: 2,
            enableShadows: true,
            skyLightIntensity: 4.0,
            directionalLightIntensity: 1.5,
            ambientLightColor: "#2f3944",
            skyLightColor: "#e8fafc",
            directionalLightColor: "#fdf6eb",
            eventTriggerImageURL: "assets/images/event_trigger.png",
            egoTriggerImageURL: "assets/images/ego_trigger.png",
            arPlacementIndicatorURL: "assets/images/placement_marker.png",
            arrowImageURL: "assets/images/arrow.png",
            customApiUrl: false,
            initialCameraAlpha: -30,
            initialCameraBeta: 25,
            enableAR: true,
            enableDebug: false,
            ignoreModelTrigger: false,
            playerFormat: "glb",
            playerResolution: "1024",
            antiAliasSamples: 2,
            postProcessExposure: 1.0,
            postProcessContrast: 1.0,
        };
    };
    VFConfigManager.enableDebug = false;
    return VFConfigManager;
}());
exports.default = VFConfigManager;
